/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Psychological category (area)
 */
export interface Category { 
    id: number;
    uuid: string;
    /**
     * Absolute path in material portal to active icon of this category
     */
    activeIconUrl: string;
    /**
     * Absolute path in material portal to inactive icon of this category
     */
    inactiveIconUrl: string;
    /**
     * Color in HEX format, e.g. #E02D2D
     */
    color: string;
    name: string;
    shortName?: string;
    /**
     * ID of the parent category, null if this category has no parent
     */
    parentId?: number;
}